import React from 'react';
import {ContainerTitle, ContainerLink, Container} from './styles'
import Linkedin from '../../../../assets/linkedin.png'
import Github from '../../../../assets/github.png'

function Title(){
  return(
    <div>
      <ContainerTitle>
        Alice Habitzreuter
      </ContainerTitle>
      <Container>
        <ContainerLink>
          <a href="https://www.linkedin.com/in/alice-habitzreuter" target='_blank' className='icon'>
            <img src={Linkedin} alt=""/>
          </a>
          <a href="https://github.com/alicehabitzreuter" target='_blank' className='icon'>
            <img src={Github} alt=""/>
          </a>
        </ContainerLink>
      </Container>
    </div>
  )
}

export default Title;